class TabsImageGallery extends HTMLElement {
  constructor() {
    super();
    this.activeTabIndex = 0;
    this.onTabClick = this.onTabClick.bind(this);
    this.onTabKeydown = this.onTabKeydown.bind(this);
  }

  connectedCallback() {
    this.initTabs();
    document.addEventListener('modalClosed', this.onModalClosed);
    document.addEventListener('modalOpened', this.onModalOpened);

    this.observer = new MutationObserver(() => this.initTabs());
    this.observer.observe(this, { childList: true, subtree: true });
  }

  initTabs() {
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.panels = this.querySelectorAll('[role="tabpanel"]');

    if (!this.tabs.length || !this.panels.length) return;

    this.tabs.forEach((tab, index) => {
      tab.dataset.tabIndex = index;
      tab.removeEventListener('click', this.onTabClick);
      tab.removeEventListener('keydown', this.onTabKeydown);
      tab.addEventListener('click', this.onTabClick);
      tab.addEventListener('keydown', this.onTabKeydown);
    });

    this.syncState();
  }

  syncState() {
    const activeIndex = [...this.tabs].findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
    this.switchTab(activeIndex >= 0 ? activeIndex : 0);
  }

  onTabClick(event) {
    const tab = event.currentTarget;
    this.switchTab(Number(tab.dataset.tabIndex || 0));
  }

  onTabKeydown(event) {
    const tab = event.currentTarget;
    this.handleKeyboard(event, Number(tab.dataset.tabIndex || 0));
  }

  switchTab(index) {
    if (!this.tabs || !this.panels || index < 0 || index >= this.tabs.length) return;

    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.classList.toggle('is-active', panelIndex === index);
    });

    this.activeTabIndex = index;
  }

  handleKeyboard(event, index) {
    if (!this.tabs.length) return;

    let targetIndex = index;

    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      targetIndex = index === 0 ? this.tabs.length - 1 : index - 1;
    } else if (event.key === 'ArrowRight') {
      event.preventDefault();
      targetIndex = index === this.tabs.length - 1 ? 0 : index + 1;
    } else if (event.key === 'Home') {
      event.preventDefault();
      targetIndex = 0;
    } else if (event.key === 'End') {
      event.preventDefault();
      targetIndex = this.tabs.length - 1;
    } else {
      return;
    }

    this.switchTab(targetIndex);
    this.tabs[targetIndex].focus();
  }

  onModalOpened = () => {
    this.initTabs();
  };

  onModalClosed = () => {};

  disconnectedCallback() {
    document.removeEventListener('modalOpened', this.onModalOpened);
    document.removeEventListener('modalClosed', this.onModalClosed);
    if (this.observer) this.observer.disconnect();
  }
}

customElements.define('tabs-image-gallery', TabsImageGallery);
